import { useTranslation } from "react-i18next";
import {
  FaAddressCard,
  FaInfoCircle,
  FaMailBulk,
  FaPhoneAlt,
} from "react-icons/fa";
import Collabse from "../../components/Collabse";
import { useAppSelector } from "../../redux/store";
import BackToHomeBtn from "../../components/BackToHomeBtn";

const AgencyInfoPage = () => {
  const { t } = useTranslation();
  const booking = useAppSelector((state) => state.booking);

  return (
    <div className="container p-10">
      <BackToHomeBtn />
      <Collabse Header={Header}>
        <div className="col">
          <h5 className="d-lg-none">
            <FaInfoCircle className="me-2" />
            {t("bookingDetails.overview.title2")}
          </h5>

          <div className="d-flex gap-3">
            <p>
              <FaAddressCard />
            </p>

            <div>
              <p className="m-0">{booking.travelAgency?.addressLine}</p>
              <p className="m-0">
                {booking.travelAgency?.street} {booking.travelAgency?.streetNo}
              </p>
              <p className="m-0">
                {booking.travelAgency?.postalCode} {booking.travelAgency?.city}
              </p>
            </div>
          </div>

          <div className="d-flex gap-3">
            <p className="m-0">
              <FaPhoneAlt />
            </p>
            <p className="m-0">{booking.travelAgency?.phoneBusiness}</p>
          </div>

          <div className="d-flex gap-3">
            <p className="m-0">
              <FaMailBulk />
            </p>
            <p className="m-0 uu">
              {booking.travelAgency?.email.replace(/\./g, ".\u200B")}
            </p>
          </div>
        </div>
      </Collabse>
      <p className="mt-4">
        Für alle Anliegen rund um Ihre Buchung bitten wir Sie, sich zunächst an
        Ihr Reisebüro oder Ihr Online-Portal zu wenden, über das Sie die Reise
        gebucht haben.
      </p>
      <p className="mt-4">
        Die Kolleginnen und Kollegen dort sind Ihre ersten Ansprechpartner und
        verfügen über die nötige Expertise, um Ihnen schnell und kompetent
        weiterzuhelfen.
      </p>
      <p className="mt-4">
        Sollte Ihr Anliegen innerhalb von 48 Stunden nicht geklärt werden
        können, steht Ihnen die Möglichkeit offen, direkt mit uns über diesen
        Weg in Kontakt zu treten.
      </p>
    </div>
  );
};

const Header = () => {
  const { t } = useTranslation();
  return (
    <h5>
      <FaInfoCircle />
      {t("bookingDetails.overview.title2")}
    </h5>
  );
};

export default AgencyInfoPage;
